import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Mail } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { AdminHeader, Panel, EmptyState } from "@/components/admin/ui";

export default function Contacts() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/contacts").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    try { await api.delete(`/contacts/${id}`); toast.success("Deleted"); load(); }
    catch (err) { toast.error(apiError(err.response?.data?.detail)); }
  };

  return (
    <div>
      <AdminHeader title="Contact Inbox" subtitle="Submissions from the public contact form." />
      {items.length === 0 ? <Panel><EmptyState>No messages yet.</EmptyState></Panel> : (
        <div className="space-y-3">
          {items.map((c) => (
            <Panel key={c.id} className="p-5" >
              <div className="flex items-start justify-between gap-4" data-testid={`contact-row-${c.id}`}>
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-white text-sm font-medium">{c.name}</span>
                    <a href={`mailto:${c.email}`} className="text-xs gold-text inline-flex items-center gap-1"><Mail size={12} /> {c.email}</a>
                    {c.phone && <span className="text-xs text-slate-500">{c.phone}</span>}
                  </div>
                  {c.subject && <p className="text-sm text-slate-300 mt-2 font-medium">{c.subject}</p>}
                  <p className="text-sm text-slate-400 mt-1 leading-relaxed whitespace-pre-line">{c.message}</p>
                  <p className="text-xs text-slate-600 mt-2 font-mono">{new Date(c.created_at).toLocaleString()}</p>
                </div>
                <button onClick={() => del(c.id)} className="p-2 text-slate-400 hover:text-red-400 shrink-0" data-testid={`contact-delete-${c.id}`}><Trash2 size={15} /></button>
              </div>
            </Panel>
          ))}
        </div>
      )}
    </div>
  );
}
